/**
 * @generated SignedSource<<3f95ea6635f22f5cee6c752dcca28b42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActiveWorkflowDashboard_company$data = {
  readonly rowId: any;
  readonly " $fragmentType": "ActiveWorkflowDashboard_company";
};
export type ActiveWorkflowDashboard_company$key = {
  readonly " $data"?: ActiveWorkflowDashboard_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActiveWorkflowDashboard_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActiveWorkflowDashboard_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "9792b7ea4753c474fb25e01be08e7c00";

export default node;
